module.exports = __webpack_public_path__ + "static/media/plus.97833658.svg";